var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shimming-line",style:(_vm.shimmingLineStyle)},[_c('ContentLoader',{attrs:{"width":_vm.width,"height":_vm.height,"speed":1,"primaryColor":_vm.primaryColor,"secondaryColor":_vm.secondaryColor}},[_c('rect',{attrs:{"x":"0","y":"0","rx":_vm.radiusTopBottom,"ry":_vm.radiusLeftRight,"width":_vm.width,"height":_vm.height}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }